import { memo } from 'react'
import { useTranslation } from '@hooks'
import { colors, IconAvatarGroup, ActionModal } from 'common-components'

import AssignSegmentRight, { AssignSegmentRightPropsType } from './AssignSegmentRight'

type AssignSegmentRightModalComponentPropsType = Pick<
  AssignSegmentRightPropsType,
  'onDeleteSegment' | 'onAddSegment' | 'isLoading' | 'segments'
> & {
  managersCount?: number
  close: () => void
  isOpen: boolean
}

const AssignSegmentRightModalComponent = ({
  segments,
  managersCount = 1,
  onDeleteSegment,
  isLoading,
  onAddSegment,
  close,
  isOpen,
}: AssignSegmentRightModalComponentPropsType) => {
  const { translate } = useTranslation()
  return (
    <ActionModal
      maskClosable={false}
      open={isOpen}
      onOk={close}
      customHeader={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconAvatarGroup
            avatars={Array.from({ length: managersCount }, () => ({
              size: 'md',
              icon: 'Announcement02',
              iconColor: colors.success700,
              borderColor: colors.white,
              iconBackground: colors.gray100,
            }))}
          />
          <div>{translate('managers.assignSegments')}</div>
        </div>
      }
      onConfirm={close}
      onCancel={close}
    >
      <AssignSegmentRight
        isLoading={isLoading}
        segments={segments}
        onAddSegment={onAddSegment}
        onDeleteSegment={onDeleteSegment}
      />
    </ActionModal>
  )
}

const AssignSegmentRightModal = memo(
  AssignSegmentRightModalComponent,
  (
    oldProps: AssignSegmentRightModalComponentPropsType,
    newProps: AssignSegmentRightModalComponentPropsType,
  ) => {
    return JSON.stringify(oldProps) === JSON.stringify(newProps)
  },
)

export default AssignSegmentRightModal
